import { format } from "./format.js";
import { createKeyCharMap } from "./key-char.js";
export function fmtime(fmt, date = new Date(), escape = "%") {
    if (!fmt) {
        return fmt;
    }
    if (isNaN(date.getTime())) {
        return undefined;
    }
    return format(fmt, createKeyCharMap(date), escape);
}
export default fmtime;
//# sourceMappingURL=index.js.map